import GroupAddressNameGenerator from "../addressGeneration/GroupAddressNameGenerator";
import { useEffect, useRef, useState } from "react";
import SettingsPage from "../components/SettingsPane/SettingsPage";
import { showToast } from "../components/Toasts";
import BaseDialog from "../modelDialogs/BaseDialog";
import ConfirmDialog from "../modelDialogs/ConfirmDialog";
import SettingsDialog from "../modelDialogs/SettingsDialog";
import BaseModel from "../models/BaseModel";
import { ChannelType } from "../models/ChannelType";
import GroupAddress from "../models/GroupAdress";
import Multiplexer from "../models/Multiplexer";
import Signal from "../models/Signal";
import { sortArrayByProperty } from "../models/utils";
import { CheckboxFieldSettings, TextFieldSettings } from "../SettingsScreen";
import { itx, T } from "../translationItx/itx";
import { isUiModeExpert } from "../uiMode";

export default function SettingPageGroupAdresses(props: {
  handler: string;
  dropDownColor: string;
  setRefresh?: (number: number) => void;
  refresh?: number;
}) {
  const { dropDownColor, setRefresh, refresh } = props;

  const isProfessionalAbo = state.projectLicense.checkIfProfessionalAbo();

  return (
    <SettingsPage
      handler="/settings/groupAddresses" // no itx
    >
      <fieldset className="form-group">
        <section className="settings-card">
          <h3 className="settings-card__header">
            {itx("SettingsScreen.groupadressShema", "Gruppenadressen Schema")}
          </h3>
          <div className="settings-card__body">
            <select
              name="knxGroupAddressGeneneration" // no itx
              key={state.settings.knxGroupAddressGeneneration}
              className={`knxGroupAddressGeneneration form-dropdown input-large`}
              onChange={async (ev: any) => {
                if (state.settings.knxGroupAddressGeneneration != ev.target.value) {
                  state.settings.knxGroupAddressGeneneration = ev.target.value;

                  if (state.addresses.size > 0) {
                    state.dialogManager.openDialog(
                      <ConfirmDialog
                        title={itx("SettingsScreen.confirmGroupAddressDeletionTitle", "Gruppenadressen löschen?")}
                        text={itx(
                          "SettingsScreen.confirmGroupAddressDeletionText",
                          "Möchten Sie wirklich alle bestehenden Gruppenadressen löschen? Wenn diese nicht gelöscht werden, kann das neue Schema nicht angewendet werden.",
                        )}
                        onAbort={() => {
                          ev.target.value = state.settings.knxGroupAddressGeneneration;
                          state.dialogManager.openDialog(<SettingsDialog defaultPane="groupAddresses" />, true);
                          return false;
                        }}
                        onClose={() => {
                          ev.target.value = state.settings.knxGroupAddressGeneneration;
                          state.dialogManager.openDialog(<SettingsDialog defaultPane="groupAddresses" />, true);
                          return false;
                        }}
                        onOk={() => {
                          GroupAddress.deleteAllReferencesToGroupAddresses(true);
                          GroupAddress.deleteAllGroupAddressesExceptOfManuals();
                          showToast({
                            text: itx(
                              "SettingsScreen.groupAddressesDeleted",
                              "Die bestehenden Gruppenadressen wurden gelöscht",
                            ),
                          });
                          state.dialogManager.openDialog(<SettingsDialog defaultPane="groupAddresses" />, true);
                          return false;
                        }}
                      />,
                    );
                  } else {
                  }
                }
              }}
              color={dropDownColor}
              defaultValue={state.settings.knxGroupAddressGeneneration}
            >
              <option value={"A"}>{itx("SettingsScreen.gAOptionA", "A: (Etage & Raum) / Funktion / Signal ")}</option>

              <option value={"B"}>
                {itx("SettingsScreen.gAOptionB", "B: (Etage & Raum) / Type / (Funktion & Signal) ")}
              </option>

              <option value={"C"}>{itx("SettingsScreen.gAOptionC", "C: Type / Etage / (Funktion & Signal)")}</option>
            </select>
            {/* // checkbox for delete not used Group Addresses */}
            <div>
              <CheckboxFieldSettings
                name="deleteNotUsedSignalTypes" // no itx
                label={itx("SettingsScreen.deleteNotUsedSignalTypes", "Nicht verwendete Signaltypen automatisch löschen")}
                onChange={async (ev) => {
                  if (state.addresses.size > 0) {
                    const changeAdresses = await state.dialogManager.openDialog(
                      <ConfirmDialog
                        title={itx("SettingsScreen.confirmGroupAddressDeletionTitle", "Gruppenadressen löschen?")}
                        text={itx(
                          "SettingsScreen.confirmGroupAddressDeletionText",
                          "Möchten Sie wirklich alle bestehenden Gruppenadressen löschen? Wenn diese nicht gelöscht werden, kann die neue Einstellung nicht angewendet werden.",
                        )}
                        onAbort={() => {
                          ev = state.settings.deleteNotUsedSignalTypes;
                          state.dialogManager.openDialog(<SettingsDialog defaultPane="groupAddresses" />, true);
                          return false;
                        }}
                        onClose={() => {
                          ev = state.settings.deleteNotUsedSignalTypes;
                          state.dialogManager.openDialog(<SettingsDialog defaultPane="groupAddresses" />, true);
                          return false;
                        }}
                        onOk={() => {
                          GroupAddress.deleteAllReferencesToGroupAddresses(true);
                          GroupAddress.deleteAllGroupAddressesExceptOfManuals();
                          showToast({
                            text: itx(
                              "SettingsScreen.groupAddressesDeleted",
                              "Die bestehenden Gruppenadressen wurden gelöscht",
                            ),
                          });
                          state.dialogManager.openDialog(<SettingsDialog defaultPane="groupAddresses" />, true);
                          return false;
                        }}
                      />,
                    );
                  } else {
                  }
                }}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            </div>
          </div>
        </section>

        <section className="settings-card">
          <h3 className="settings-card__header">
            {itx(
              "SettingsScreen.followingChannelTypesShouldHaveLockGroupAdress",
              "Sperr-Gruppenadressen erstellen für:",
            )}
          </h3>
          <div className="settings-card__body">
            {/* <CheckboxFieldSettings
              name="groupAddresses.useLockForSwitch" // no itx
              label={itx("channelType." + ChannelType.Switch, "")}
              onChange={() => {}}
              setRefresh={setRefresh}
              refresh={refresh}
            />
            <CheckboxFieldSettings
              name="groupAddresses.useLockForDim" // no itx
              label={itx("channelType." + ChannelType.Dimmer, "")}
              onChange={() => {}}
              setRefresh={setRefresh}
              refresh={refresh}
            /> */}

            <CheckboxFieldSettings
              name="groupAddresses.useLockForJalousie" // no itx
              label={itx("channelType." + ChannelType.Jalousie, "")}
              onChange={() => {}}
              setRefresh={setRefresh}
              refresh={refresh}
            />

          </div>
        </section>

        {isUiModeExpert() && isProfessionalAbo && (
          <GroupAddressTemplateSelector setRefresh={setRefresh} refresh={refresh} />
        )}
      </fieldset>
    </SettingsPage>
  );
}

type GroupAddressTemplateObjectType = "ButtonChannel" | "Consumer" | "Multiplexer";

function GroupAddressTemplateSelector(props: { setRefresh?: (number: number) => void; refresh?: number }) {
  const { setRefresh, refresh } = props;
  const [selectedObjType, setSelectedObjType] = useState<GroupAddressTemplateObjectType>("ButtonChannel");
  // resetKey is intentionally separate from selectedTemplate.
  // TextFieldSettings uses `defaultValue` internally, so React does not update the input
  // after the initial mount. To force a remount (and thus show the new value), we change
  // this key — but ONLY when needed (tab switch or reset button), NOT on every keystroke.
  // Using selectedTemplate as the key would cause a remount on every character typed,
  // which resets cursor position and loses focus.
  const [resetKey, setResetKey] = useState(0);
  const inputWrapperRef = useRef<HTMLDivElement>(null);
  const possibleVariableGroups = {
    ButtonChannel: [
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupFloor", "Etage"),
        variables: ["floor.fullTag", "floor.tag", "floor.name"], // no itx
      },
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupRoom", "Raum"),
        variables: ["room.fullTag", "room.tag", "room.name"], // no itx
      },
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupButton", "Taste"),
        variables: ["button.fullTag", "button.tag", "button.name"], // no itx
      },
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupButtonChannel", "Tastenkanal"),
        variables: ["buttonChannel.fullTag", "buttonChannel.tag", "buttonChannel.nameOrConnectedNames"], // no itx
      },

      {
        groupLabel: itx("SettingsScreen.templateVariableGroupSignal", "Signal"),
        variables: ["signalType", "signalTypeShort"], // no itx
      },
    ],
    Consumer: [
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupFloor", "Etage"),
        variables: ["floor.fullTag", "floor.tag", "floor.name"], // no itx
      },
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupRoom", "Raum"),
        variables: ["room.fullTag", "room.tag", "room.name"], // no itx
      },
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupConsumer", "Verbraucher"),
        variables: ["consumer.fullTag", "consumer.tag", "consumer.name"], // no itx
      },
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupSignal", "Signal"),
        variables: ["signalType", "signalTypeShort"], // no itx
      },
    ],
    Multiplexer: [
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupMultiplexer", "Multiplexer"),
        variables: ["multiplexer.tag", "multiplexer.name"], // no itx
      },
      {
        groupLabel: itx("SettingsScreen.templateVariableGroupSignal", "Signal"),
        variables: ["signalType", "signalTypeShort"], // no itx
      },
    ],
  }[selectedObjType];

  const variableMap = possibleVariableGroups.reduce(
    (res, group) => {
      group.variables.forEach((variable) => {
        const [leftPart, ...rightParts] = variable.split(".");
        const rightPart = rightParts.join(".");

        if (!res[leftPart]) {
          res[leftPart] = [];
        }
        if (!res[leftPart].includes(rightPart)) {
          res[leftPart].push(rightPart);
        }
      });
      return res;
    },
    {} as Record<string, string[]>,
  );

  const leftOptions = Object.keys(variableMap);
  const [selectedLeftPart, setSelectedLeftPart] = useState(leftOptions[0] || "");
  const [selectedRightPart, setSelectedRightPart] = useState((variableMap[leftOptions[0]] || [""])[0]);

  useEffect(() => {
    const firstLeftPart = Object.keys(variableMap)[0] || "";
    const firstRightPart = (variableMap[firstLeftPart] || [""])[0];
    setSelectedLeftPart(firstLeftPart);
    setSelectedRightPart(firstRightPart);
    // Increment resetKey so the input field remounts with the correct defaultValue for the new tab.
    setResetKey((k) => k + 1);
  }, [selectedObjType]);

  const rightOptions = variableMap[selectedLeftPart] || [];

  let selectedName:
    | "groupAddresses.buttonChannelNameTemplate" // no itx
    | "groupAddresses.consumerNameTemplate" // no itx
    | "groupAddresses.multiplexerNameTemplate" = "groupAddresses.buttonChannelNameTemplate"; // no itx
  let selectedLabel = itx("SettingsScreen.forButtons", "von Tasten");
  let selectedTemplate = state.settings.groupAddresses.buttonChannelNameTemplate;

  if (selectedObjType === "Consumer") {
    selectedName = "groupAddresses.consumerNameTemplate"; // no itx
    selectedLabel = itx("SettingsScreen.forConsumer", "von Verbrauchern");
    selectedTemplate = state.settings.groupAddresses.consumerNameTemplate;
  }

  if (selectedObjType === "Multiplexer") {
    selectedName = "groupAddresses.multiplexerNameTemplate"; // no itx
    selectedLabel = itx("SettingsScreen.forMultiplexer", "von Multiplexern");
    selectedTemplate = state.settings.groupAddresses.multiplexerNameTemplate;
  }

  const insertVariableAtCursor = (variable: string) => {
    const input = inputWrapperRef.current?.querySelector("input") as HTMLInputElement | null;
    if (!input) {
      return;
    }

    const insertion = "${" + variable + "}"; // no itx
    const selectionStart = input.selectionStart ?? input.value.length;
    const selectionEnd = input.selectionEnd ?? selectionStart;
    const newValue = input.value.substring(0, selectionStart) + insertion + input.value.substring(selectionEnd);

    input.value = newValue;

    if (selectedObjType === "ButtonChannel") {
      state.settings.groupAddresses.buttonChannelNameTemplate = newValue;
    }
    if (selectedObjType === "Consumer") {
      state.settings.groupAddresses.consumerNameTemplate = newValue;
    }
    if (selectedObjType === "Multiplexer") {
      state.settings.groupAddresses.multiplexerNameTemplate = newValue;
    }

    if (setRefresh && refresh != undefined) {
      setRefresh(refresh + 1);
    }

    input.focus();
    const cursorPos = selectionStart + insertion.length;
    input.setSelectionRange(cursorPos, cursorPos);

    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true })); // no itx
  };
  function Tab(props: { label: string; value: GroupAddressTemplateObjectType }) {
    const { label, value } = props;
    return (
      <button
        className="btn button"
        style={{
          marginRight: "6px",
          border: "1px solid #ccc",
          borderBottom: selectedObjType === value ? "1px solid #eee" : "1px solid #ccc",
          backgroundColor: selectedObjType === value ? "var(--selectedOrange)" : "#f7f7f7",
          fontWeight: selectedObjType === value ? "bold" : "normal",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
          marginBottom: "-1px",
          height: "fit-content",
        }}
        onClick={() => setSelectedObjType(value)}
      >
        {label}
      </button>
    );
  }

  return (
    <>
      <div style={{ marginTop: "10px" }}>
        <div className="estadaRow left" style={{ marginBottom: "0px", alignItems: "flex-end" }}>
          <Tab label={itx("SettingsScreen.forButtons", "von Tasten")} value="ButtonChannel" />
          <Tab label={itx("SettingsScreen.forConsumer", "Verbrauchern")} value="Consumer" />
          <Tab label={itx("SettingsScreen.forMultiplexer", "Multiplexern")} value="Multiplexer" />
        </div>
        <div
          className="settings-card settings-card__body"
          style={{
            padding: "16px",
            marginTop: "0px",
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: "2px solid var(--warning-color)",
                borderRadius: "5px",
                padding: "10px",
                backgroundColor: "#d3b20b13",
                marginBottom: "10px",
              }}
            >
              <i
                className="las la-exclamation-triangle"
                style={{ color: "var(--warning-color)", marginRight: "10px", fontSize: "30px" }}
              />
              {itx(
                "SettingsScreen.followingRulesAdvancedFeatureGroupAdresses",
                "Die folgenden Regeln zur Bennenung von Gruppenadressen sind ein sehr fortgeschrittenes Feature.",
              )}
              <br />
              {itx("SettingsScreen.onlyIfExpert", "Bitte verwenden Sie es nur, wenn Sie genau wissen, was Sie tun.")}
            </div>
            <div className="form-label-bold" style={{}}>
              {itx("SettingsScreen.templateVariables", "Verfügbare Variablen:")}
            </div>
            <div
              className="estadaRow left"
              style={{
                gap: "8px",
                marginBottom: "10px",
                alignItems: "center",

                padding: "8px",
              }}
            >
              <div style={{ minWidth: "180px" }}>
                <select
                  className="form-dropdown input-standard"
                  style={{ width: "100%", height: "30px", margin: "0px", display: "block", boxSizing: "border-box" }}
                  value={selectedLeftPart}
                  onChange={(ev) => {
                    const newLeftPart = ev.target.value;
                    const firstRightPart = (variableMap[newLeftPart] || [""])[0];
                    setSelectedLeftPart(newLeftPart);
                    setSelectedRightPart(firstRightPart);
                  }}
                >
                  {leftOptions.map((leftPart) => (
                    <option key={leftPart} value={leftPart}>
                      {leftPart}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ minWidth: "220px" }}>
                <select
                  className="form-dropdown input-standard"
                  style={{ width: "100%", height: "30px", margin: "0px", display: "block", boxSizing: "border-box" }}
                  value={selectedRightPart}
                  onChange={(ev) => setSelectedRightPart(ev.target.value)}
                  disabled={rightOptions.length <= 1 && rightOptions[0] === ""}
                >
                  {rightOptions.map((rightPart) => (
                    <option key={rightPart || "(empty)"} value={rightPart}>
                      {rightPart || itx("SettingPageGroupAdresses.ohneunterfeld", "(ohne Unterfeld)")}
                    </option>
                  ))}
                </select>
              </div>

              <button
                type="button"
                className="button circle"
                style={{}}
                onMouseDown={(ev) => {
                  ev.preventDefault();
                  const variableToInsert = selectedRightPart
                    ? `${selectedLeftPart}.${selectedRightPart}`
                    : selectedLeftPart;
                  insertVariableAtCursor(variableToInsert);
                }}
                data-tooltip-id="tv-tooltip"
                data-tooltip-content={itx("SettingPageGroupAAddresses.add", "Variable hinzufügen")}
                data-tooltip-place="top" // no itx
              >
                <i className="las la-plus-circle" />
              </button>
            </div>

            <div ref={inputWrapperRef}>
              <TextFieldSettings
                // Remount only when resetKey changes (tab switch or reset button), not on every keystroke.
                key={selectedName + "|" + resetKey}
                name={selectedName} // no itx
                label={
                  itx("SettingPageGroupAAddresses.templates", "Templates für die Namen von Gruppenadressen") +
                  selectedLabel
                }
                width="100%"
                setRefresh={setRefresh}
                refresh={refresh}
              />
            </div>
          </div>

          <div className="settings-card__actions">
            <button
              type="button"
              className="button white"
              onClick={() => {
                state.dialogManager.pushDialog(
                  "signalNamePatternTest", // no itx
                  <PatternTestDialog template={selectedTemplate} objType={selectedObjType} />,
                  true,
                );
              }}
            >
              Test
            </button>
            <button
              className="button circle"
              style={{
                marginBottom: "0px",
                height: "30px",
                display: "flex",
                alignItems: "center",
              }}
              data-tooltip-id="tv-tooltip"
              data-tooltip-content={itx(
                "SettingPageGroupAdresses.resetToDefault",
                "Standardeinstellungen wiederherstellen",
              )}
              data-tooltip-place="top" // no itx
              onClick={() => {
                if (selectedObjType === "ButtonChannel") {
                  state.settings.groupAddresses.buttonChannelNameTemplate =
                    state.settings.default_buttonChannelNameTemplate;
                } else if (selectedObjType === "Consumer") {
                  state.settings.groupAddresses.consumerNameTemplate = state.settings.default_consumerNameTemplate;
                } else if (selectedObjType === "Multiplexer") {
                  state.settings.groupAddresses.multiplexerNameTemplate =
                    state.settings.default_multiplexerNameTemplate;
                } else {
                  showToast({
                    text: itx("SettingsScreen.unknownType", "Unbekannter Typ"),
                  });
                }
                // Increment resetKey so the input field remounts and shows the restored default value.
                setResetKey((k) => k + 1);
                if (setRefresh && refresh != undefined) {
                  setRefresh(refresh + 1);
                }
              }}
            >
              <i className="las la-undo-alt" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

function PatternTestDialog(props: { template: string; objType: "Consumer" | "ButtonChannel" | "Multiplexer" }) {
  const { template, objType } = props;

  state.settings.applyGroupAddressNameTemplates();

  const testSignals = new Array<{ obj: BaseModel; signal: Signal }>();

  switch (objType) {
    case "Consumer":
      sortArrayByProperty(state.allConsumers(), "fullTag").forEach((consumer) => {
        consumer.signals.forEach((signal: Signal) => {
          testSignals.push({ obj: consumer, signal });
        });
      });
      break;

    case "ButtonChannel":
      sortArrayByProperty(state.allButtons(), "tagOrName").forEach((button) => {
        button.buttonChannels.forEach((buttonChannel) => {
          if (buttonChannel.connections.size > 1) {
            buttonChannel.signals.forEach((signal) => {
              testSignals.push({ obj: buttonChannel, signal });
            });
          }
        });
      });
      break;

    case "Multiplexer":
      state.sceneGroup
        .sortBy("tagOrName")
        .filter((multiplexer) => multiplexer.isMultiplexer)
        .forEach((multiplexer) => {
          (multiplexer as Multiplexer).signals.forEach((signal) => {
            testSignals.push({ obj: multiplexer, signal });
          });
        });
      break;
  }

  return (
    <BaseDialog
      dialogId="signalNamePatternTest"
      title={itx("SettingsScreen.PatternTestDialogTitle", "Gruppenadressen Template Test")}
      noAbortButton={true}
    >
      <div>{itx("SettingsScreen.patternTestDialogGeneratedNames", "Generierte Gruppenadressnamen")}</div>
      <br />

      <div style={{ maxHeight: "400px", overflow: "auto", border: "1px solid #ccc", padding: "10px" }}>
        {testSignals.length > 0 && (
          <table>
            <tbody>
              {testSignals.map((item) => {
                let name = "";
                switch (objType) {
                  case "ButtonChannel":
                    name = state.settings.groupAddressNameGenerator.generateGroupAddressNameForButtonChannel(
                      item.obj as any,
                      item.signal,
                    );
                    break;
                  case "Multiplexer":
                    name = state.settings.groupAddressNameGenerator.generateGroupAddressNameForMultiplexer(
                      item.obj as any,
                      item.signal,
                    );
                    break;
                  case "Consumer":
                    name = state.settings.groupAddressNameGenerator.generateGroupAddressNameForConsumer(
                      item.obj as any,
                      item.signal,
                    );
                    break;
                }

                return (
                  <tr key={item.obj.id + item.signal.id}>
                    <td>{name}</td>
                    <td>
                      {
                        "<=" // no itx
                      }
                    </td>
                    <td>{item.obj.tag}</td>
                    <td>{item.obj.name}</td>
                    <td>{item.signal.type.name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        {testSignals.length === 0 && <div>Keine Signale gefunden.</div>}
      </div>
    </BaseDialog>
  );
}
